/* ============================================================
   MontanaTags redesign — shared behavior  (Phase 0, issue #3)
   Ported from style-guide/scripts/mt.js.

   All DOM work is scoped to `.mt-scope` roots so it can never touch
   the existing theme markup. Every hook is null-guarded, so loading
   this before any redesign sections exist is a no-op.
   ============================================================ */
(function () {
  'use strict';

  var roots = function () { return document.querySelectorAll('.mt-scope'); };
  var qsa = function (sel) {
    var out = [];
    roots().forEach(function (r) { r.querySelectorAll(sel).forEach(function (n) { out.push(n); }); });
    return out;
  };

  /* ---------- scroll reveal ---------- */
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      // threshold 0: reveal as soon as any part crosses into the (reduced)
      // viewport. A fractional threshold never fires for elements taller than
      // that fraction of the viewport — e.g. the search-results ledger.
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' })
    : null;
  function bindReveal() {
    var els = qsa('.reveal:not(.in)');
    if (!io) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- nav solidify on scroll ---------- */
  var nav = document.querySelector('.mt-scope .nav, .mt-scope.nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 30); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile drawer ---------- */
  var drawer = document.querySelector('.mt-scope .drawer, .mt-scope.drawer') || document.getElementById('drawer');
  document.querySelectorAll('.mt-scope [data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (drawer) drawer.classList.add('open'); });
  });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.matches('.drawer-scrim,[data-drawer-close]')) drawer.classList.remove('open');
    });
  }

  /* ---------- header search panel ---------- */
  var searchPanel = document.getElementById('mt-nav-search');
  var searchToggles = document.querySelectorAll('.mt-scope [data-search-toggle]');
  if (searchPanel && searchToggles.length) {
    var setSearchOpen = function (open) {
      searchPanel.hidden = !open;
      searchToggles.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) { var i = searchPanel.querySelector('.nav-search-input'); if (i) i.focus(); }
    };
    searchToggles.forEach(function (b) {
      b.addEventListener('click', function () { setSearchOpen(searchPanel.hidden); });
    });
    searchPanel.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]')) setSearchOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hidden) setSearchOpen(false);
    });
  }

  /* ---------- graceful image fallback ---------- */
  qsa('.imgwrap img').forEach(function (img) {
    var mark = function () { var w = img.closest('.imgwrap'); if (w) w.classList.add('broken'); };
    if (img.complete && img.naturalWidth === 0) mark();
    img.addEventListener('error', mark);
  });

  /* ============================================================
     SAVINGS ESTIMATOR
     Type a vehicle + home state; estimate the sales tax saved.
     ============================================================ */
  var STATE_RATES = { // approximate vehicle sales/use tax, %
    california: 7.25, nevada: 8.25, arizona: 5.6, washington: 6.5, oregon: 0, texas: 6.25,
    florida: 6, 'new york': 8, illinois: 6.25, colorado: 2.9, utah: 6.1,
    georgia: 6.6, tennessee: 7, 'north carolina': 3, virginia: 4.15,
    'new jersey': 6.625, massachusetts: 6.25, michigan: 6, ohio: 5.75,
    pennsylvania: 6, louisiana: 4.45, kansas: 6.5, missouri: 4.225, minnesota: 6.5,
    wisconsin: 5, indiana: 7, kentucky: 6, alabama: 2, oklahoma: 4.5, arkansas: 6.5,
    connecticut: 6.35, maryland: 6, 'south carolina': 5, idaho: 6,
    'new mexico': 4, hawaii: 4, montana: 0, alaska: 0, 'new hampshire': 0, delaware: 0
  };
  var VEHICLES = [
    { k: ['ferrari', 'lamborghini', 'mclaren', 'bugatti', 'hypercar', 'exotic', 'aston', 'bentley', 'rolls', 'royce', 'porsche', 'exotics'], label: 'Exotic / supercar', price: 300000 },
    { k: ['g wagon', 'g-wagon', 'g63', 'g-class', 'range rover', 'rover', 'suv', 'escalade'], label: 'Luxury SUV', price: 160000 },
    { k: ['motorhome', 'rv', 'motorcoach', 'coach', 'tiffin', 'prevost', 'airstream'], label: 'Motorcoach / RV', price: 425000 },
    { k: ['boat', 'yacht', 'watercraft', 'vessel', 'wakeboard'], label: 'Boat / watercraft', price: 185000 },
    { k: ['sxs', 'side by side', 'side-by-side', 'utv', 'rzr', 'can-am', 'can am', 'razor'], label: 'SXS / UTV', price: 42000 },
    { k: ['motorcycle', 'harley', 'ducati', 'dirt bike', 'bike'], label: 'Motorcycle', price: 34000 },
    { k: ['classic', 'vintage', 'collector', 'restomod', 'hot rod', 'antique'], label: 'Vintage / collector', price: 140000 },
    { k: ['truck', 'f150', 'f-150', 'raptor', 'diesel', 'ram'], label: 'Truck', price: 95000 },
    { k: ['fleet', 'commercial', 'vans', 'sprinter'], label: 'Commercial fleet', price: 520000 },
    { k: ['tesla', 'rivian', 'electric', 'ev', 'lucid'], label: 'Electric vehicle', price: 110000 },
    { k: ['car', 'sedan', 'coupe', 'vehicle', 'automobile'], label: 'Automobile', price: 120000 }
  ];

  var fmt = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };

  function parsePrice(t) {
    t = t.replace(/,/g, '');
    // Only explicit $ amounts count as a price — typical input is just make/model
    // + state, and model names contain digits and letters ("X7 M", "F-150", "911")
    // that must never be read as a dollar value.
    var m = t.match(/\$\s?(\d+(?:\.\d+)?)\s?(k|thousand)\b/i); if (m) return parseFloat(m[1]) * 1000;
    m = t.match(/\$\s?(\d+(?:\.\d+)?)\s?(m|million|mil)\b/i); if (m) return parseFloat(m[1]) * 1000000;
    m = t.match(/\$\s?(\d{4,})/); if (m) return parseFloat(m[1]);
    return null;
  }
  function parseState(t) {
    var keys = Object.keys(STATE_RATES);
    var multi = keys.filter(function (k) { return k.includes(' '); }).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < multi.length; i++) { if (t.includes(multi[i])) return { name: multi[i], rate: STATE_RATES[multi[i]] }; }
    var map = { cali: 'california', ny: 'new york', jersey: 'new jersey', mass: 'massachusetts', vegas: 'nevada', socal: 'california', 'bay area': 'california' };
    for (var a in map) { if (new RegExp('\\b' + a + '\\b').test(t)) { var n = map[a]; return { name: n, rate: STATE_RATES[n] }; } }
    for (var j = 0; j < keys.length; j++) { if (keys[j].length > 3 && t.includes(keys[j])) return { name: keys[j], rate: STATE_RATES[keys[j]] }; }
    return null;
  }
  function parseVehicle(t) {
    for (var i = 0; i < VEHICLES.length; i++) { for (var j = 0; j < VEHICLES[i].k.length; j++) { if (t.includes(VEHICLES[i].k[j])) return VEHICLES[i]; } }
    return null;
  }
  var titleCase = function (s) { return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); }); };

  function estimate(raw) {
    var t = ' ' + raw.toLowerCase().replace(/[^a-z0-9$.,\s-]/g, ' ').replace(/\s+/g, ' ') + ' ';
    var veh = parseVehicle(t);
    var st = parseState(t);
    var price = parsePrice(t);
    if (!price) price = veh ? veh.price : 150000;
    var rate = st ? st.rate : 7.25;
    var stName = st ? titleCase(st.name) : null;
    var saved = price * (rate / 100);
    return { price: price, rate: rate, saved: saved, vehLabel: veh ? veh.label : 'Vehicle', stName: stName };
  }

  qsa('[data-vc]').forEach(function (vc) {
    var go = vc.querySelector('.vc-go');
    var input = vc.querySelector('.vc-input');
    var hint = vc.querySelector('.vc-hint');
    var out = vc.querySelector('.vc-out');
    var saveEl = vc.querySelector('.vc-save');
    var detail = vc.querySelector('.vc-detail');

    function render(res) {
      saveEl.innerHTML = '<small>Estimated sales tax saved</small>' + fmt(res.saved);
      var stLine = res.stName ? ('registering in <b>' + res.stName + '</b> (' + res.rate + '%)') : 'at an average <b>' + res.rate + '%</b> rate';
      detail.innerHTML = '<b>' + res.vehLabel + '</b> valued near <b>' + fmt(res.price) + '</b>, ' + stLine + '. Your Montana LLC pays <b>$0</b> sales tax — keeping the full amount in your pocket.';
      out.classList.add('show');
    }
    function run() {
      var val = (input.value || '').trim();
      if (!val) { hint.textContent = 'Enter a vehicle and your home state — e.g. "Ferrari in California".'; input.focus(); return; }
      hint.textContent = 'Estimate based on typical retail value — request an exact quote for your VIN.';
      render(estimate(val));
    }
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    if (go) go.addEventListener('click', run);
    vc.querySelectorAll('.vc-chip').forEach(function (ch) { ch.addEventListener('click', function () { input.value = ch.dataset.q || ch.textContent; run(); }); });
  });

  /* ---------- hero slideshow ---------- */
  function bindHeroSlideshows() {
    qsa('[data-hero-slideshow]:not([data-mt-bound])').forEach(function (show) {
      show.setAttribute('data-mt-bound', '1');
      var slides = show.querySelectorAll('[data-hero-slide]');
      if (slides.length < 2) return;
      var hero = show.closest('.heroB');
      var nav = hero ? hero.querySelector('[data-slide-nav]') : null;
      var dots = nav ? nav.querySelectorAll('[data-slide-to]') : [];
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = show.dataset.autoplay !== 'false' && !reduced;
      var interval = parseInt(show.dataset.interval, 10) || 6000;
      var current = 0;
      var timer = null;

      function go(i) {
        current = (i % slides.length + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          s.classList.toggle('active', j === current);
          s.setAttribute('aria-hidden', j === current ? 'false' : 'true');
        });
        dots.forEach(function (d, j) {
          d.classList.toggle('active', j === current);
          if (j === current) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() {
        stop();
        if (autoplay) timer = setInterval(function () { if (!document.hidden) go(current + 1); }, interval);
      }

      if (nav) {
        nav.addEventListener('click', function (e) {
          var btn = e.target.closest('button');
          if (!btn) return;
          if (btn.hasAttribute('data-slide-prev')) go(current - 1);
          else if (btn.hasAttribute('data-slide-next')) go(current + 1);
          else if (btn.hasAttribute('data-slide-to')) go(parseInt(btn.getAttribute('data-slide-to'), 10) || 0);
          play(); // restart the countdown so a manual choice isn't advanced away early
        });
      }
      if (hero) {
        hero.addEventListener('mouseenter', stop);
        hero.addEventListener('mouseleave', play);
        hero.addEventListener('focusin', stop);
        hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) play(); });
      }
      play();
    });
  }

  /* ---------- nav "estimate" shortcut ---------- */
  var estBtn = document.querySelector('.mt-scope [data-estimate-jump]');
  if (estBtn) {
    estBtn.addEventListener('click', function () {
      var el = document.getElementById('estimator') || document.getElementById('concierge');
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); var i = el.querySelector('.vc-input'); setTimeout(function () { if (i) i.focus(); }, 650); }
    });
  }

  bindReveal();
  bindHeroSlideshows();
  // Theme editor re-renders sections in place; rebind behavior for the new DOM.
  document.addEventListener('shopify:section:load', function () {
    bindReveal();
    bindHeroSlideshows();
  });
  window.MT = { bindReveal: bindReveal, bindHeroSlideshows: bindHeroSlideshows, estimate: estimate };
})();
